import React from "react";
import PropTypes from "prop-types";
import "../cell.scss";

/** This component is created to display name of cell and Cell context component on right end */
const CellHeader = (props) => {
  const {children, name} = props;

  return (
    <div className="cell--header" data-cy={"cell_header"}>
      <div className="cell--draggable">
        <div className="cell--dot-grid" />
        <div className="cell--dot-grid" />
        <div className="cell--dot-grid" />
      </div>
      <div className="cell--name">{name}</div>
      {children}
    </div>
  );
};

CellHeader.propTypes = {
  /** Children to be displayed on right end */
  children: PropTypes.node,
  /** Title of cell */
  name: PropTypes.string.isRequired,
};

export default CellHeader;
